// Same name as the static <title> in public/index.html.
export const APP_TITLE = 'FlixBus - Data Sharing Portal';

// Sets the browser tab title for the current page; React 19 moves <title> into <head>.
const PageTitle = ({ title }) => <title>{`${title} | ${APP_TITLE}`}</title>;

export default PageTitle;
